import React from 'react';
import { Brand } from 'cpie-common';
import { OptionsOverview } from './options-overview';
import { RenewalOptions } from './renewal-options';
import { DealerInformationView } from './dealer-information-view';
import { ContractEndOptionsView } from './enums';

export const ContractEndOptionsStep: React.FC<{
    contractEndOptionsView: ContractEndOptionsView;
    setContractEndOptionsView: (contractEndOptionsView: ContractEndOptionsView) => void;
    contractNumber: string;
    brand?: Brand;
    header: React.ReactNode;
}> = ({ contractEndOptionsView, setContractEndOptionsView, contractNumber, brand, header }) => {
    switch (contractEndOptionsView) {
        case ContractEndOptionsView.DEALER_INFORMATION:
            return (
                <DealerInformationView
                    handleBackClick={setContractEndOptionsView}
                    contractNumber={contractNumber}
                    header={header}
                />
            );
        case ContractEndOptionsView.RENEWAL_OPTIONS:
            return (
                <RenewalOptions
                    handleSubmit={setContractEndOptionsView}
                    handleBackClick={setContractEndOptionsView}
                    header={header}
                />
            );
        case ContractEndOptionsView.OPTIONS_OVERVIEW:
        default:
            return <OptionsOverview handleSubmit={setContractEndOptionsView} brand={brand} header={header} />;
    }
};
